import React, { useState, useEffect, useRef, useCallback } from 'react'
import Picker from 'emoji-picker-react'
import { useHistory } from 'react-router-dom'
import { getChatToken } from './../../_services/index'
import { userService } from '../../_services'

import ConversationHeader from './ConversationHeader'
import ConversationCard from './ConversationCard'
import MessageInput from './MessageInput'

function Conversation({
    client,
    channelDetails,
    chatRef,
    messages,
    setMessages,
    initialLoading: loading,
    sendMessage,
    hostProfileImage,
    showMobileConversation,
    setShowMobileConversation,
    setText,
    text,
    setActiveChannelId,
}) {
    const [showPicker, setShowPicker] = useState(false)
    const [userAttributes, setAttributes] = useState(channelDetails?.channel?.attributes ?? [])

    const onEmojiClick = emojiObject => {
        setText(prevInput => prevInput + emojiObject.emoji)
        setShowPicker(false)
    }

    const fetchMemberDetails = async () => {
        try {
            const channel = await client.current.getConversationBySid(channelDetails.channel.sid)

            const members = await channel.getParticipants()

            setAttributes(channel.attributes.property)
        } catch (err) {
            console.error('Failed to fetch member details:', err)
        }
    }

    useEffect(() => {
        fetchMemberDetails()
    }, [channelDetails?.channel?.sid, channelDetails?.channel?.attributes])

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                overflow: 'hidden',
                borderLeft: '1px solid #E5E7EB',
                height: 'calc(100vh - 20vh)',
            }}
            className={`coversition-content ${showMobileConversation ? "" : "hidden"}`}
        >
            <>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                        <div style={{ backgroundColor: 'white', margin: 'auto', borderRadius: '0.375rem', padding: '1rem' }}>
                            <div className="loader"></div>
                        </div>
                    </div>
                ) : channelDetails ? (
                    <>
                        <ConversationHeader
                            setShowMobileConversation={setShowMobileConversation}
                            channelDetails={{
                                channelId: channelDetails.channel.uniqueName,
                                sid: channelDetails.channel.sid,
                                name: channelDetails.channel.friendlyName,
                                property:
                                    (channelDetails.channel.attributes &&
                                        Object.keys(channelDetails.channel.attributes).length > 0 &&
                                        channelDetails.channel.attributes.property) ||
                                    '',
                            }}
                            setActiveChannelId={setActiveChannelId}
                        />
                        <div
                            ref={chatRef}
                            style={{
                                flexGrow: 1,
                                overflowY: 'scroll',
                                paddingLeft: '1rem',
                                msOverflowStyle: 'none',
                                scrollbarWidth: 'none',
                            }}
                        >
                            {messages.map((curr, ind) => (
                                <ConversationCard key={ind} userDetails={userAttributes} messageInstance={curr} hostProfileImage={hostProfileImage} />
                            ))}
                            {showPicker && <Picker pickerStyle={{ width: '100%' }} onEmojiClick={e => onEmojiClick(e)} />}
                        </div>
                        <MessageInput
                            text={text}
                            setText={setText}
                            sendMessage={sendMessage}
                            showPicker={showPicker}
                            setShowPicker={setShowPicker}
                            onEmojiClick={onEmojiClick}
                        />
                    </>
                ) : null}
            </>
        </div>
    )
}

export default Conversation
